import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import UseDefaultAndSpaceClassificationLevelsQueryRelayArtifact from '../hooks/__generated__/useDefaultAndSpaceClassificationLevelsQuery.graphql';

export function preloadDefaultAndSpaceClassificationLevels(spaceKey: string = '') {
	return query({
		query: UseDefaultAndSpaceClassificationLevelsQueryRelayArtifact,
		variables: {
			spaceKey,
		},
	});
}
